module.exports = __webpack_public_path__ + "img/SketchPng380cbab89569fcb3529aefe404c176d140e2a133ae07d2ffb78700f8807bf4c5.3f554087.png";